import icon from "../../assets/port-count.svg";
import type { Property } from "../../types";

export const portCount: Property = {
  id: "portCount",
  title: "portCount.title",
  icon,
};
